type LoginAuthorityMode = "tenant" | "common" | "auto";

const parseDomainList = (value?: string): string[] =>
  (value ?? "")
    .split(",")
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean);

// Fallback enterprise domains for /common login in "auto" mode.
// Can be overridden at deploy time with REACT_APP_COMMON_LOGIN_DOMAINS.
const defaultEnterpriseDomains = [
  "wdhnt.onmicrosoft.com",
  "simplify-solutions.tech",
];

const configuredAuthorityMode = (
  window.ENV_CONFIG?.REACT_APP_LOGIN_AUTHORITY_MODE ?? "tenant"
).toLowerCase();

const loginAuthorityMode: LoginAuthorityMode =
  configuredAuthorityMode === "common" || configuredAuthorityMode === "auto"
    ? configuredAuthorityMode
    : "tenant";

const configuredCommonLoginDomains = parseDomainList(
  window.ENV_CONFIG?.REACT_APP_COMMON_LOGIN_DOMAINS,
);
const commonLoginDomains =
  configuredCommonLoginDomains.length > 0
    ? configuredCommonLoginDomains
    : defaultEnterpriseDomains;

// Fallback credentials for local development only
// In production, these MUST be provided via ENV_CONFIG
const DEFAULT_CLIENT_ID = "869098b4-1f7e-41bb-9653-875cece129a5";
const DEFAULT_TENANT_ID = "7abbd1a7-be55-4ad9-9123-98170cd07d56";

const settings: AppSettings = {
  // Use environment variables with fallback to defaults for development
  clientId: window.ENV_CONFIG?.REACT_APP_CLIENT_ID || DEFAULT_CLIENT_ID,
  tenantId: window.ENV_CONFIG?.REACT_APP_TENANT_ID || DEFAULT_TENANT_ID,
  graphUserScopes: ["Calendars.Read", "Calendars.Read.Shared"],
  googleClientId: window.ENV_CONFIG?.REACT_APP_GOOGLE_CLIENT_ID || "",
  loginAuthorityMode,
  commonLoginDomains,
};

export interface AppSettings {
  clientId: string;
  tenantId: string;
  graphUserScopes: string[];
  googleClientId: string;
  loginAuthorityMode: LoginAuthorityMode;
  commonLoginDomains: string[];
}

export default settings;
